import React, { FC } from 'react';
import { StatusChip, StatusChipType } from '@beeline.com/bp-design-system';
import { useStatusChipIntl } from 'src/components/common/StatusChipTranslations/useStatusChipIntl';
import { JobProfileStatusModel } from 'src/graphql/types';

interface Props {
  status: JobProfileStatusModel;
}

export const JobProfileStatusChip: FC<Props> = ({ status }) => {
  const intl = useStatusChipIntl();

  return (
    <StatusChip
      dataTest="job-profile-status"
      label={intl[status]}
      type={status === 'ACTIVE' ? StatusChipType.LIGHT_BLUE : StatusChipType.GREY}
    />
  );
};
